import MediaplanTemplates from 'routes/MediaplanTemplates/components/MediaplanTemplates';

export default MediaplanTemplates;
